import { Directive } from '@angular/core';

@Directive({
  // tslint:disable-next-line:directive-selector
  selector: '.axis-carousel-wrapper'
})
// tslint:disable-next-line:directive-class-suffix
export class CarouselItemElement {

  constructor() { }

}
